import React from 'react';
interface LogoProps {
  variant?: 'dark' | 'light';
  className?: string;
}
export function Logo({
  variant = 'dark',
  className = ''
}: LogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/vENXSPg13wXetnyFiq84Yz/725756930_18021743144848492_3365414875200421082_n.jpg" alt="Royal Pool Cleaning" className={`h-12 md:h-14 w-auto object-contain ${variant === 'light' ? 'invert mix-blend-screen' : 'mix-blend-multiply'} ${className}`} data-id="element-178" />;
}